export const chartTimeFrameConfig = [
    {
        timeFrame:'D',
        fullName: 'Day',
        adverb:'Daily'
    },
    {
        timeFrame:'W',
        fullName: 'Week',
        adverb:'Weekly'
    },
    {
        timeFrame:'M',
        fullName: 'Month',
        adverb:'Monthly'
    },
    {
        timeFrame:'MIN1',
        fullName: '1 minute',
        adverb:'Minutely'
    },
    {
        timeFrame:'MIN5',
        fullName: '5 minutes',
        adverb:'Minutely'
    },
    {
        timeFrame:'MIN15',
        fullName: '15 minutes',
        adverb:'Minutely'
    },
    {
        timeFrame:'MIN30',
        fullName: '30 minutes',
        adverb:'Minutely'
    },
    {
        timeFrame:'H1',
        fullName: '1 hour',
        adverb:'Hourly'
    },
    {
        timeFrame:'H2',
        fullName: '2 hours',
        adverb:'Hourly'
    },
    {
        timeFrame:'H4',
        fullName: '4 hours',
        adverb:'Hourly'
    },
]